"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MULTISIG_OPERATIONS = exports.MAX_SIGNERS = void 0;
exports.MAX_SIGNERS = 11;
exports.MULTISIG_OPERATIONS = 2;
//# sourceMappingURL=constants.js.map